import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import FormField from './FormField';
import { Grid } from '@material-ui/core';
const styles = () => ({
    padding: {
        padding: '20',
    },
});

class FormDisplay extends React.Component {
    render() {
        return (
            <Grid container spacing={2}>
                {this.props.subEntries.map((entry) => (
                    <Grid item key={entry.field} xs={12} md={entry.width || 12} className={this.props.classes.padding}>
                        <FormField field={entry} value={''} />
                    </Grid>
                ))}
            </Grid>
        );
    }
}

export default withStyles(styles)(FormDisplay);
